import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import {
  acceptRequest,
  cancelRequest,
  deleteRequest,
  follow,
  addFriend,
} from "../../functions/user";
import { useToast } from "../../components/ToastContainer";

export default function Card({ userr, type, getData }) {
  const { user } = useSelector((state) => ({ ...state }));
  const { showSuccess, showError } = useToast();
  const cancelRequestHandler = async (userId) => {
    const res = await cancelRequest(userId, user.token);
    if (res === "ok") {
      getData();
    }
  };
  const confirmHandler = async (userId) => {
    const res = await acceptRequest(userId, user.token);
    if (res === "ok") {
      getData();
      showSuccess(`✅ You are now friends with ${userr.name || `${userr.first_name} ${userr.last_name}`}!`, 4000);
    } else {
      showError("❌ Failed to accept friend request. Please try again.", 4000);
    }
  };
  const deleteHandler = async (userId) => {
    const res = await deleteRequest(userId, user.token);
    if (res === "ok") {
      getData();
      showError(`❌ Friend request from ${userr.name || `${userr.first_name} ${userr.last_name}`} declined`, 3000);
    } else {
      showError("❌ Failed to decline friend request. Please try again.", 4000);
    }
  };
  
  const followHandler = async (userId) => {
    const res = await follow(userId, user.token);
    if (res === "ok") {
      getData();
    }
  };
  
  const addFriendHandler = async (userId) => {
    const res = await addFriend(userId, user.token);
    if (res === "ok") {
      getData();
    }
  };
  return (
    <div className="req_card">
      <Link to={`/profile/${userr.username}`}>
        <img src={userr.picture} alt="" />
      </Link>
      <div className="req_name">
        {userr.name || `${userr.first_name || ""} ${userr.last_name || ""}`.trim()}
      </div>
      {type === "sent" ? (
        <button
          className="blue_btn"
          onClick={() => cancelRequestHandler(userr._id)}
        >
          Cancel Request
        </button>
      ) : type === "request" ? (
        <>
          <button
            className="blue_btn"
            onClick={() => confirmHandler(userr._id)}
          >
            Confirm
          </button>
          <button className="gray_btn" onClick={() => deleteHandler(userr._id)}>
            Delete
          </button>
        </>
      ) : type === "suggestion" ? (
        <div className="suggestion_buttons">
          <button
            className="blue_btn"
            onClick={() => addFriendHandler(userr._id)}
          >
            Add Friend
          </button>
          <button
            className="gray_btn"
            onClick={() => followHandler(userr._id)}
          >
            Follow
          </button>
          
        </div>
      ) : (
        ""
      )}
    </div>
  );
}
